import React, { useState } from 'react'
import $t from '../../../i18n'
import { useDispatch } from 'react-redux'
import Actions from '../../../actions'
import { Button } from 'antd'
import config from '../../../config.json'
import AppDownloadConfirmationDialog from '../dialogs/AppDownloadConfirmationDialog'
import { isMobileWeb } from '../../../utils/detectMobileWeb'
import { event, eventTypes } from '../../../consts/eventConsts'
import Page from '../../common/Page'

import './MediaDenied.css'

const MediaDenied = () => {
  const dispatch = useDispatch()

  const [isTroubleShootModelOpened, setIsTroubleShootModelOpened] =
    useState(false)

  const sendLinkToMobile = () => {
    if (isMobileWeb()) {
      window.open(config.downloadAppForMobile, '_blank')
    } else {
      dispatch(Actions.createAction(Actions.SHOW_APP_DOWNLOAD_LINK_POP_UP))
    }
    setTimeout(() => {
      dispatch(Actions.createAction(Actions.ENABLE_DOWNLOAD_LINK_BUTTON))
    }, 10000)
  }

  const togleExpandTroubleshootModel = () => {
    setIsTroubleShootModelOpened(!isTroubleShootModelOpened)
  }

  const renderTroubleShootingButton = () => {
    return (
      <div
        data-name={$t(
          'pages.mediaDenied.troubleshootCameraAndMicrophoneAccess'
        )}
        className="troubleshoot-button link trackable"
        onClick={togleExpandTroubleshootModel}
      >
        {$t('pages.mediaDenied.troubleshootCameraAndMicrophoneAccess')}
      </div>
    )
  }

  const renderContinueButton = () => {
    return (
      <div className="continue-btn-container">
        <Button
          type="primary"
          className="media-denied-continue-btn"
          onClick={() => {
            window.location.reload()
            dispatch(
              Actions.createAction(Actions.ANALYTICS_EVENT_FIRED, {
                type: eventTypes.formEvent,
                eventName: event.formEvent.submit,
                data: {
                  question_id: 'camera_microphone_denied',
                  question_text: $t('pages.mediaDenied.info'),
                  answer_text: $t('pages.mediaDenied.continue'),
                },
                element: 'Camera Permissions',
              })
            )
          }}
        >
          {$t('pages.mediaDenied.continue')}
        </Button>
      </div>
    )
  }

  const renderMediaDeniedNote = () => {
    return (
      <div className="troubleshooot-modal-wrapper">
        <div
          className={
            isTroubleShootModelOpened
              ? 'expanded-trouble-shoot-model-container'
              : 'trouble-shoot-model-container'
          }
        >
          <div className={'media-denied-note'}>
            <div className="bold">{$t('pages.mediaDenied.note')} </div>
            <ul className="steps">
              <li className="step">
                <div className="step-text">
                  {'1. ' + $t('pages.mediaDenied.steps.topRight')}
                </div>
              </li>
              <li className="step">
                <div className="step-text">
                  {'2. ' + $t('pages.mediaDenied.steps.settings')}
                </div>
              </li>
              <li className="step">
                <div className="step-text">
                  {'3. ' + $t('pages.mediaDenied.steps.privacy')}
                </div>
              </li>
              <li className="step">
                <div className="step-text">
                  {'4. ' + $t('pages.mediaDenied.steps.site')}
                </div>
              </li>
            </ul>
            {$t('pages.mediaDenied.downloadAppDesc')}&nbsp;
            <span className="download-app-btn" onClick={sendLinkToMobile}>
              {$t('pages.mediaDenied.downloadMobile')}
            </span>
            .
          </div>
        </div>
      </div>
    )
  }

  return (
    <Page
      title={$t('pages.mediaDenied.title')}
      subtitle={$t('pages.mediaDenied.info')}
      className="media-denied-screen"
    >
      {renderContinueButton()}
      {renderTroubleShootingButton()}
      {renderMediaDeniedNote()}
      <AppDownloadConfirmationDialog />
    </Page>
  )
}

export default MediaDenied
